// extracted by mini-css-extract-plugin
module.exports = {"chessContainer":"style_chessContainer__L9xVZ","pointer-events-none":"style_pointer-events-none__e2WAS"};